export default "__VITE_ASSET__O1vg$MnA__"